import apiConfig from "constants/apiConfig"
import axiosClient from "utils/axiosClient"

export const searchCreators = async (agencyId: string, filters: any) => {
    const response = await axiosClient.post(apiConfig.SEARCH_CREATORS.url.replace('<agencyId>', agencyId), filters);
    return response.data;
}